import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material';

@Component({
	selector: 'upm-confirm-discard-dialog',
	templateUrl: './confirm-discard-dialog.component.html',
	styleUrls: ['./confirm-discard-dialog.component.less']
})
export class ConfirmDiscardDialogComponent {

	name: string = '';

	constructor(@Inject(MAT_DIALOG_DATA) public data: { name: string }) {
		this.name = data.name;
	}

}
